// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1zdmc9ImNsb3NlIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGNDkxMDMiIHN0cm9rZS13aWR0aD0iMi4wNiIgZD0iTTE2IDE2IDQgNE0xNiA0IDQgMTYiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locationPickerWrapper--beSnT {
  position: absolute;
}

[dir=ltr] .menuControlButton--O0jyb {
  margin-right: 4px !important;
}

[dir=rtl] .menuControlButton--O0jyb {
  margin-left: 4px !important;
}

[dir] .notSelected--OphPu {
  border: 1px solid transparent;
}

.locationItem--NEbE5:hover {
  text-decoration: underline !important;
  color: #444 !important;
}

.appMenu--AvGfm {
  width: 100vw;
  position: relative;
  display: flex;
  justify-content: center;
}

[dir] .appMenu--AvGfm {
  background: #f7dbd4;
  padding-top: 32px;
  padding-bottom: 32px;
}
.menuContainer--Dj14U {
  max-width: none;
  width: 100%;
}
[dir] .menuContainer--Dj14U {
  background: #fff;
  padding: 24px;
  margin: 0 auto;
}
.menuDescription--ALqlF {
  font-size: 1.1rem;
  color: #333;
}
[dir] .menuDescription--ALqlF {
  margin: 0 0 16px 0;
}

.groupIcon--x10F_ {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  flex-shrink: 0;
}
.menuSearchWrapper--qwocF {
  width: 100%;
  display: flex;
  align-items: center;
}
.menuSearch--DnCrf {
  width: 100%;
  font-size: 1rem;
}
[dir] .menuSearch--DnCrf {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.pillButton--ceOQa {
  font-size: 0.95rem;
  color: #222;
  transition:
    background 0.15s,
    border 0.15s,
    box-shadow 0.15s;
  outline: none;
  position: relative;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
[dir] .pillButton--ceOQa {
  background: #f9fafb;
  border: 1.5px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}
[dir=ltr] .pillButton--ceOQa {
  padding: 8px 16px 8px 12px;
}
[dir=rtl] .pillButton--ceOQa {
  padding: 8px 12px 8px 16px;
}
[dir] .pillButton--ceOQa:hover {
  background: #b5b5b5;
  border-color: #343c42;
  box-shadow: none;
}
.pillButton--ceOQa:focus {
  outline: none;
}

.pillText--GdlXQ {
  flex: 1;
  font-weight: 500;
}

[dir=ltr] .pillText--GdlXQ {
  text-align: left;
}

[dir=rtl] .pillText--GdlXQ {
  text-align: right;
}
.pillIcons--Fy9Al {
  display: flex;
  align-items: center;
  gap: 2px;
}
[dir=ltr] .pillIcons--Fy9Al {
  margin-left: 8px;
}
[dir=rtl] .pillIcons--Fy9Al {
  margin-right: 8px;
}
.arrowIcon--efgol {
  color: #2563eb;
  vertical-align: middle;
}
[dir=ltr] .arrowIcon--efgol {
  margin-right: 2px;
}
[dir=rtl] .arrowIcon--efgol {
  margin-left: 2px;
}
.closeButton--HEQqf {
  color: #888;
  display: flex;
  align-items: center;
  transition: background 0.15s;
}
[dir] .closeButton--HEQqf {
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}
[dir=ltr] .closeButton--HEQqf {
  padding: 0 0 0 2px;
  margin-left: 2px;
}
[dir=rtl] .closeButton--HEQqf {
  padding: 0 2px 0 0;
  margin-right: 2px;
}
.closeButton--HEQqf:focus {
  outline: none;
}
.closeButton--HEQqf:hover {
  color: #ef4444;
}
[dir] .closeButton--HEQqf:hover {
  background: #f3f4f6;
}
.allPill--y7XVt {
  font-weight: 700;
  color: #2563eb;
}
[dir] .allPill--y7XVt {
  margin-bottom: 12px;
  background: #f3f4f6;
  border: 2px solid #dbeafe;
}
[dir] .pillButton--ceOQa + .allPill--y7XVt {
  margin-top: 16px;
}
[dir] .pillButton--ceOQa:not(:first-child) {
  margin-top: 0;
}
[dir] .pillButton--ceOQa:not(.allPill--y7XVt) {
  margin-bottom: 8px;
}
.menuContentWrapper--Dv_dl {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.countriesColumn--Hkt0B,
.groupsColumn--_GqjZ {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.columnTitle--vr3uz {
  font-weight: 700;
  font-size: 1.1rem;
  color: #222;
}
[dir] .columnTitle--vr3uz {
  margin-bottom: 12px;
}
.pillList--ImzY0 {
  display: flex;
  flex-direction: column;
  gap: 0;
}
[dir] .customGroupsSection--X0yh5 {
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}
.customGroupsTitle--SArml {
  font-weight: 600;
  color: #222;
}
[dir] .customGroupsTitle--SArml {
  margin-bottom: 8px;
}

.customGroupsList--oRPXS {
  list-style: none;
  color: #444;
}

[dir] .customGroupsList--oRPXS {
  margin: 0;
  padding: 0;
}

.customGroupItem--L080k {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

[dir] .customGroupItem--L080k {
  padding: 8px;
  margin-bottom: 4px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

[dir] .customGroupItem--L080k:hover {
  background: #e9ecef;
}

.customGroupName--FSt1z {
  font-size: inherit;
  color: #333;
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

[dir] .customGroupName--FSt1z {
  background: none;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
}

[dir=ltr] .customGroupName--FSt1z {
  text-align: left;
}

[dir=rtl] .customGroupName--FSt1z {
  text-align: right;
}

.customGroupName--FSt1z:hover {
  color: #007bff;
  text-decoration: underline;
}

.customGroupName--FSt1z.selected--grTxE {
  color: white;
  font-weight: bold;
}

[dir] .customGroupName--FSt1z.selected--grTxE {
  background: #007bff;
  border: 2px solid #0056b3;
}

.customGroupName--FSt1z.selected--grTxE:hover {
  color: white;
  text-decoration: none;
}

[dir] .customGroupName--FSt1z.selected--grTxE:hover {
  background: #0056b3;
}

.groupNameText--CyjkB {
  flex: 1;
}

.editIcon--JwCV4 {
  width: 16px;
  height: 16px;
  color: #6c757d;
}

.customGroupActions--WOedA {
  display: flex;
  gap: 4px;
}

.customGroupEdit--PU_ON,
.customGroupDelete--Zb41P {
  font-size: 16px;
  opacity: 0.7;
}

[dir] .customGroupEdit--PU_ON, [dir] .customGroupDelete--Zb41P {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
}

.customGroupEdit--PU_ON:hover,
.customGroupDelete--Zb41P:hover {
  opacity: 1;
}

[dir] .customGroupEdit--PU_ON:hover, [dir] .customGroupDelete--Zb41P:hover {
  background: rgba(0, 0, 0, 0.1);
}

.deleteIcon--okfaJ {
  width: 18px;
  height: 18px;
  color: #dc3545;
}

.groupFlagPreview--HkWfT {
  display: flex;
  align-items: center;
  position: relative;
}

.previewFlag--pIyZa {
  width: 20px;
  height: 20px;
  -o-object-fit: cover;
     object-fit: cover;
  position: relative;
}

[dir] .previewFlag--pIyZa {
  border-radius: 50%;
  border: 2px solid white;
}

[dir=ltr] .previewFlag--pIyZa {
  margin-left: -8px;
}

[dir=rtl] .previewFlag--pIyZa {
  margin-right: -8px;
}

[dir=ltr] .previewFlag--pIyZa:first-child {
  margin-left: 0;
}

[dir=rtl] .previewFlag--pIyZa:first-child {
  margin-right: 0;
}

.moreCountriesIndicator--soIY7 {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

[dir] .moreCountriesIndicator--soIY7 {
  background: #f3f4f6;
  padding: 2px 6px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
}

[dir=ltr] .moreCountriesIndicator--soIY7 {
  margin-left: 4px;
}

[dir=rtl] .moreCountriesIndicator--soIY7 {
  margin-right: 4px;
}

.modal--gV4LK {
  position: fixed;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

[dir] .modal--gV4LK {
  background: rgba(0, 0, 0, 0.5);
}

[dir=ltr] .modal--gV4LK {
  left: 0;
  right: 0;
}

[dir=rtl] .modal--gV4LK {
  right: 0;
  left: 0;
}

.modalContent--tO7DF {
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

[dir] .modalContent--tO7DF {
  background: white;
  padding: 24px;
  border-radius: 8px;
}

.modalContent--tO7DF h3 {
  color: #333;
}

[dir] .modalContent--tO7DF h3 {
  margin: 0 0 16px 0;
}

[dir] .formGroup--BnU4d {
  margin-bottom: 16px;
}

.formGroup--BnU4d label {
  display: block;
  font-weight: 600;
  color: #333;
}

[dir] .formGroup--BnU4d label {
  margin-bottom: 4px;
}

.input--sTVzk {
  width: 100%;
  font-size: 16px;
}

[dir] .input--sTVzk {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.input--sTVzk:focus {
  outline: none;
}

.countrySelector--fn4xn {
  max-height: 200px;
  overflow-y: auto;
}

[dir] .countrySelector--fn4xn {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  background: #f8f9fa;
}

.countryCheckbox--d2T53 {
  display: flex;
  align-items: center;
  font-size: 16px;
}

[dir] .countryCheckbox--d2T53 {
  padding: 6px 0;
  cursor: pointer;
}

[dir=ltr] .countryCheckbox--d2T53 input {
  margin-right: 8px;
}

[dir=rtl] .countryCheckbox--d2T53 input {
  margin-left: 8px;
}

.countryFlag--UlCxY {
  width: 20px;
  height: 20px;
  -o-object-fit: cover;
     object-fit: cover;
}

[dir] .countryFlag--UlCxY {
  border-radius: 50%;
}

[dir=ltr] .countryFlag--UlCxY {
  margin-right: 8px;
}

[dir=rtl] .countryFlag--UlCxY {
  margin-left: 8px;
}

.countryName--_wdtJ {
  flex: 1;
}

[dir] .customGroupSearchWrapper--_Z4mF {
  margin-bottom: 12px;
}

.customGroupSearchInput--GiYpA {
  width: 100%;
  font-size: 16px;
  box-sizing: border-box;
}

[dir] .customGroupSearchInput--GiYpA {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
}

.customGroupSearchInput--GiYpA:focus {
  outline: none;
}

.selectedCountries--xw5gp {
  font-size: 16px;
}

[dir] .selectedCountries--xw5gp {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.selectedCountriesLabel--YW8Mq::after {
  content: ': ';
}

.selectedCountriesPills--Rl9HH {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

[dir] .selectedCountriesPills--Rl9HH {
  margin-top: 6px;
}

.countryPill--b9yia {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #222;
  transition: all 0.15s;
}

[dir] .countryPill--b9yia {
  background: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

[dir=ltr] .countryPill--b9yia {
  padding: 3px 4px 3px 6px;
}

[dir=rtl] .countryPill--b9yia {
  padding: 3px 6px 3px 4px;
}

[dir] .countryPill--b9yia:hover {
  background: #e5e7eb;
  border-color: #9ca3af;
}

.pillFlag--iRpcV {
  width: 16px;
  height: 16px;
  -o-object-fit: cover;
     object-fit: cover;
}

[dir] .pillFlag--iRpcV {
  border-radius: 50%;
}

[dir=ltr] .pillFlag--iRpcV {
  margin-right: 5px;
}

[dir=rtl] .pillFlag--iRpcV {
  margin-left: 5px;
}

.pillText--GdlXQ {
  font-weight: 500;
}

[dir=ltr] .pillText--GdlXQ {
  margin-right: 3px;
}

[dir=rtl] .pillText--GdlXQ {
  margin-left: 3px;
}

.pillRemove--Cp18r {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  color: #6b7280;
}

[dir] .pillRemove--Cp18r {
  background: none;
  border: none;
  cursor: pointer;
  padding: 1px;
  border-radius: 4px;
}

.pillRemove--Cp18r:hover {
  color: #374151;
}

[dir] .pillRemove--Cp18r:hover {
  background: #e5e7eb;
}

.pillCloseIcon--ABLLE {
  width: 12px;
  height: 12px;
}

.noSelection--q2sOw {
  color: #6c757d;
  font-style: italic;
}

.modalActions--FLEm3 {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

[dir] .modalActions--FLEm3 {
  margin-top: 20px;
}

.cancelButton--bWwcR {
  color: #333;
}

[dir] .cancelButton--bWwcR {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
}

[dir] .cancelButton--bWwcR:hover {
  background: #f8f9fa;
}

.saveButton--rBMfK {
  color: white;
}

[dir] .saveButton--rBMfK {
  padding: 8px 16px;
  border: none;
  background: #007bff;
  border-radius: 4px;
  cursor: pointer;
}

[dir] .saveButton--rBMfK:hover {
  background: #0056b3;
}
.menuSearch--DnCrf:focus {
  outline: none;
}

@media (min-width: 901px) {
  .menuContentWrapper--Dv_dl {
    flex-direction: row;
    gap: 32px;
  }
  .pillButton--ceOQa {
    min-width: 120px;
    font-size: 1rem;
  }
  [dir=ltr] .pillButton--ceOQa {
    padding: 10px 28px 10px 18px;
  }
  [dir=rtl] .pillButton--ceOQa {
    padding: 10px 18px 10px 28px;
  }
}

.countriesSectionBox--VXoZy {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
}

[dir] .countriesSectionBox--VXoZy {
  background: none;
  border: 1.5px solid #d1d5db;
  border-radius: 4px;
  padding: 10px 20px 10px 20px;
  margin-bottom: 16px;
}

[dir=ltr] .countriesSectionBox--VXoZy {
  margin-right: 0;
}

[dir=rtl] .countriesSectionBox--VXoZy {
  margin-left: 0;
}
.groupsSectionBox--BCQ5w {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
}
[dir] .groupsSectionBox--BCQ5w {
  background: none;
  border: 1.5px solid #d1d5db;
  border-radius: 4px;
  padding: 10px 20px 10px 20px;
  margin-bottom: 0;
}
[dir=ltr] .groupsSectionBox--BCQ5w {
  margin-left: 0;
}
[dir=rtl] .groupsSectionBox--BCQ5w {
  margin-right: 0;
}
.menuContentWrapperGrid--wRmE_ {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
}
.countriesColumnGrid--RgkGL {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.groupsColumnGrid--NDcGL {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.countriesGrid--oegCj {
  -moz-column-count: 1;
       column-count: 1;
  -moz-column-gap: 20px;
       column-gap: 20px;
}
[dir] .countriesGrid--oegCj {
  margin-top: 8px;
}
[dir] .groupsListGrid--Qp6nY {
  margin-top: 8px;
}
.countriesGrid--oegCj > a,
.countriesGrid--oegCj > button,
.groupsListGrid--Qp6nY > a,
.groupsListGrid--Qp6nY > button {
  -moz-column-break-inside: avoid;
       break-inside: avoid;
  width: 100%;
}
[dir] .countriesGrid--oegCj > a, [dir] .countriesGrid--oegCj > button, [dir] .groupsListGrid--Qp6nY > a, [dir] .groupsListGrid--Qp6nY > button {
  margin-bottom: 8px;
}
.squareButton--BhbXx {
  font-size: 1rem;
  color: #222;
  transition:
    background 0.15s,
    border 0.15s,
    box-shadow 0.15s;
  outline: none;
  min-width: 0;
  min-height: 26px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
  position: relative;
  overflow: visible;
  height: auto !important;
  width: 100%;
  text-decoration: none;
}
[dir] .squareButton--BhbXx {
  background: #fff;
  border: 1.5px solid #d1d5db;
  border-radius: 4px;
  padding: 4px 8px 4px 8px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.squareButton--BhbXx:visited,
.squareButton--BhbXx:focus,
.squareButton--BhbXx:active {
  color: #222;
  text-decoration: none;
}
.squareButton--BhbXx.selected--grTxE {
  font-weight: bold;
}
[dir] .squareButton--BhbXx.selected--grTxE {
  background: #ccced0;
  border: 1.5px solid #343c42;
  border-radius: 4px;
}
[dir=ltr] .squareButton--BhbXx.selected--grTxE {
  padding-right: 23px;
}
[dir=rtl] .squareButton--BhbXx.selected--grTxE {
  padding-left: 23px;
}
/* Decorative close (x) on selected buttons – matches measures tab & custom groups */
.squareButton--BhbXx.selected--grTxE::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 18px;
  height: 18px;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}
[dir] .squareButton--BhbXx.selected--grTxE::after {
  transform: translateY(-50%);
  background: rgba(52, 60, 66, 0.5);
}
[dir=ltr] .squareButton--BhbXx.selected--grTxE::after {
  right: 6px;
}
[dir=rtl] .squareButton--BhbXx.selected--grTxE::after {
  left: 6px;
}
.squareButton--BhbXx:hover {
  text-decoration: none;
  color: #222;
}
[dir] .squareButton--BhbXx:hover {
  border: 1.5px solid #343c42;
}

.squareButton--BhbXx:hover .squareText--w94XJ,
.squareButton--BhbXx:focus .squareText--w94XJ,
.squareButton--BhbXx:active .squareText--w94XJ,
.squareButton--BhbXx:visited .squareText--w94XJ {
  color: inherit;
}
[dir] .squareButton--BhbXx.selected--grTxE:hover {
  background: #b5b5b5 !important;
  border-color: #343c42 !important;
  box-shadow: none !important;
}
.squareText--w94XJ {
  flex: 1;
  color: inherit;

  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  display: block;
  max-width: 100%;
  line-height: 1.2;
  word-break: break-word;
}
[dir=ltr] .squareText--w94XJ {
  text-align: left;
  margin-left: 4px;
}
[dir=rtl] .squareText--w94XJ {
  text-align: right;
  margin-right: 4px;
}
.flagIcon--zoxVx {
  width: 22px;
  height: 22px;
  -o-object-fit: cover;
     object-fit: cover;
  align-self: flex-start;
}
[dir] .flagIcon--zoxVx {
  border-radius: 50%;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
}
[dir=ltr] .flagIcon--zoxVx {
  margin-right: 2px;
}
[dir=rtl] .flagIcon--zoxVx {
  margin-left: 2px;
}
.closeButton--HEQqf {
  color: #888;
  display: flex;
  align-items: center;
  transition: background 0.15s;
  position: absolute;
  top: 50%;
  z-index: 2;
}
[dir] .closeButton--HEQqf {
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  transform: translateY(-50%);
}
[dir=ltr] .closeButton--HEQqf {
  padding: 0 0 0 2px;
  margin-left: 6px;
  right: 8px;
}
[dir=rtl] .closeButton--HEQqf {
  padding: 0 2px 0 0;
  margin-right: 6px;
  left: 8px;
}
.closeButton--HEQqf:hover {
  color: #ef4444;
}
[dir] .closeButton--HEQqf:hover {
  background: #f3f4f6;
}
.allButton--AFgM3 {
  color: #222;
  width: auto;
  justify-content: flex-start;
}
[dir] .allButton--AFgM3 {
  margin-bottom: 0;
  background: #fff;
  border: 1.5px solid #d1d5db;
}
.allRow--VRhjY {
  width: 100%;
  display: flex;
}
[dir] .allRow--VRhjY {
  margin-bottom: 0;
}
.menuSearch--DnCrf:focus {
  outline: none;
}

@media (min-width: 768px) {
  .menuContentWrapperGrid--wRmE_ {
    flex-direction: row;
    align-items: flex-start;
  }
  .countriesColumnGrid--RgkGL {
    flex: 2 1 0;
  }
  .groupsColumnGrid--NDcGL {
    flex: 1 1 0;
  }
  .countriesGrid--oegCj {
    -moz-column-count: 2;
         column-count: 2;
  }
  .countriesSectionBox--VXoZy {
    width: auto;
  }
  [dir] .countriesSectionBox--VXoZy {
    margin-bottom: 0;
  }
  [dir=ltr] .countriesSectionBox--VXoZy {
    margin-right: 8px;
  }
  [dir=rtl] .countriesSectionBox--VXoZy {
    margin-left: 8px;
  }
  .groupsSectionBox--BCQ5w {
    width: auto;
  }
  [dir=ltr] .groupsSectionBox--BCQ5w {
    margin-left: 8px;
  }
  [dir=rtl] .groupsSectionBox--BCQ5w {
    margin-right: 8px;
  }
}

@media (min-width: 1100px) {
  .countriesGrid--oegCj {
    -moz-column-count: 3;
         column-count: 3;
  }
  [dir=ltr] .countriesSectionBox--VXoZy {
    margin-right: 12px;
  }
  [dir=rtl] .countriesSectionBox--VXoZy {
    margin-left: 12px;
  }
  [dir=ltr] .groupsSectionBox--BCQ5w {
    margin-left: 0;
  }
  [dir=rtl] .groupsSectionBox--BCQ5w {
    margin-right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/LocationPickerMenu/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAFA;EACE,2BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EAEZ,kBAAkB;EAGlB,aAAa;EACb,uBAAuB;AACzB;;AARA;EAEE,mBAAmB;EAEnB,iBAAiB;EACjB,oBAAoB;AAGtB;AACA;EAIE,eAAe;EACf,WAAW;AACb;AANA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;AAGhB;AACA;EACE,iBAAiB;EACjB,WAAW;AAEb;AAJA;EAGE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EAIX,eAAe;AACjB;AANA;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AAEpB;AACA;EAKE,kBAAkB;EAClB,WAAW;EAEX;;;oBAGkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AAEzB;AAnBA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAIlB,eAAe;EAWf,yCAAyC;AAC3C;AAnBA;EAIE,0BAA0B;AAe5B;AAnBA;EAIE,0BAA0B;AAe5B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EAEP,gBAAgB;AAClB;;AAJA;EAEE,gBAAgB;AAElB;;AAJA;EAEE,iBAAgB;AAElB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AAEV;AALA;EAIE,gBAAgB;AAClB;AALA;EAIE,iBAAgB;AAClB;AACA;EACE,cAAc;EAEd,sBAAsB;AACxB;AAJA;EAEE,iBAAiB;AAEnB;AAJA;EAEE,gBAAiB;AAEnB;AACA;EAME,WAAW;EACX,aAAa;EACb,mBAAmB;EAEnB,4BAA4B;AAC9B;AAXA;EACE,gBAAgB;EAChB,YAAY;EAGZ,eAAe;EAIf,kBAAkB;AAEpB;AAXA;EAGE,kBAAkB;EAClB,gBAAgB;AAOlB;AAXA;EAGE,kBAAkB;EAClB,iBAAgB;AAOlB;AACA;EACE,aAAa;AACf;AACA;EAEE,cAAc;AAChB;AAHA;EACE,mBAAmB;AAErB;AACA;EAEE,gBAAgB;EAGhB,cAAc;AAChB;AANA;EACE,mBAAmB;EAEnB,mBAAmB;EACnB,yBAAyB;AAE3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EAEjB,WAAW;AACb;AALA;EAGE,mBAAmB;AAErB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAEhB,WAAW;AACb;AAJA;EAEE,kBAAkB;AAEpB;;AAEA;EAGE,gBAAgB;EAChB,WAAW;AACb;;AALA;EACE,SAAS;EACT,UAAU;AAGZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EAMnB,QAAQ;AACV;;AAVA;EAIE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAE3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAIE,kBAAkB;EAClB,WAAW;EAGX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AAEV;;AAbA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EAGjB,eAAe;EAMf,kBAAkB;AACpB;;AAbA;EAOE,gBAAgB;AAMlB;;AAbA;EAOE,iBAAgB;AAMlB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EAEE,YAAY;EACZ,iBAAiB;AAEnB;;AALA;EACE,mBAAmB;EAGnB,yBAAyB;AAC3B;;AAEA;EAEE,YAAY;EACZ,qBAAqB;AACvB;;AAJA;EACE,mBAAmB;AAGrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAME,eAAe;EACf,YAAY;AAEd;;AATA;EAEE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EAGf,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AAEZ;;AAJA;EAGE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,oBAAiB;KAAjB,iBAAiB;EAEjB,kBAAkB;AACpB;;AARA;EAGE,kBAAkB;EAClB,uBAAuB;AAIzB;;AARA;EAME,iBAAiB;AAEnB;;AARA;EAME,kBAAiB;AAEnB;;AAEA;EACE,cAAc;AAChB;;AAFA;EACE,eAAc;AAChB;;AAEA;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAKlB;;AATA;EAKE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AATA;EACE,gBAAgB;AAQlB;;AATA;EACE,iBAAgB;AAQlB;;AAEA;EACE,eAAe;EACf,MAAM;EAGN,SAAS;EAET,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAXA;EAME,8BAA8B;AAKhC;;AAXA;EAGE,OAAO;EACP,QAAQ;AAOV;;AAXA;EAGE,QAAO;EACP,OAAQ;AAOV;;AAEA;EAIE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AARA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AAKpB;;AAEA;EAEE,WAAW;AACb;;AAHA;EACE,kBAAkB;AAEpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EAEd,gBAAgB;EAChB,WAAW;AACb;;AALA;EAEE,kBAAkB;AAGpB;;AAEA;EACE,WAAW;EAIX,eAAe;AACjB;;AANA;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AAEpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAKlB;;AAPA;EAGE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EAGnB,eAAe;AACjB;;AANA;EAGE,cAAc;EACd,eAAe;AAEjB;;AAEA;EACE,iBAAiB;AACnB;;AAFA;EACE,gBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AANA;EAGE,kBAAkB;AAGpB;;AANA;EAIE,iBAAiB;AAEnB;;AANA;EAIE,gBAAiB;AAEnB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EAIX,eAAe;EACf,sBAAsB;AACxB;;AAPA;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AAGpB;;AAEA;EACE,aAAa;AACf;;AAEA;EAKE,eAAe;AACjB;;AANA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAE3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AAEV;;AALA;EAIE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EAKnB,eAAe;EACf,WAAW;EAEX,qBAAqB;AACvB;;AAXA;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAIlB,yCAAyC;AAE3C;;AAXA;EAME,wBAAwB;AAK1B;;AAXA;EAME,wBAAwB;AAK1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AANA;EAGE,kBAAkB;AAGpB;;AANA;EAIE,iBAAiB;AAEnB;;AANA;EAIE,gBAAiB;AAEnB;;AAEA;EACE,gBAAgB;AAElB;;AAHA;EAEE,iBAAiB;AACnB;;AAHA;EAEE,gBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAMvB,4BAA4B;EAC5B,cAAc;AAChB;;AAXA;EAIE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AAGpB;;AAEA;EAEE,cAAc;AAChB;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AAEV;;AALA;EAIE,gBAAgB;AAClB;;AAEA;EAIE,WAAW;AAGb;;AAPA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EAEjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAIE,YAAY;AAGd;;AAPA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EAEnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,eAAe;EAEjB;EAJA;IAGE,4BAA4B;EAC9B;EAJA;IAGE,4BAA4B;EAC9B;AACF;;AAEA;EAOE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAXA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAE5B,mBAAmB;AAKrB;;AAXA;EAKE,eAAe;AAMjB;;AAXA;EAKE,cAAe;AAMjB;AACA;EAOE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AAXA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAE5B,gBAAgB;AAKlB;AAXA;EAKE,cAAc;AAMhB;AAXA;EAKE,eAAc;AAMhB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,oBAAe;OAAf,eAAe;EACf,qBAAgB;OAAhB,gBAAgB;AAElB;AAJA;EAGE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;;;EAIE,+BAAmB;OAAnB,mBAAmB;EACnB,WAAW;AAEb;AAPA;EAME,kBAAkB;AACpB;AACA;EAKE,eAAe;EACf,WAAW;EAEX;;;oBAGkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAE3B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;AAzBA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EAGxB,eAAe;EAWf,yCAAyC;AAO3C;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;AACvB;AACA;EAIE,iBAAiB;AAEnB;AANA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AAGpB;AANA;EAKE,mBAAmB;AACrB;AANA;EAKE,kBAAmB;AACrB;AACA,oFAAoF;AACpF;EACE,WAAW;EACX,kBAAkB;EAElB,QAAQ;EAER,WAAW;EACX,YAAY;EAEZ,qDAA+Q;EAC/Q,6CAAuQ;EACvQ,oBAAoB;AACtB;AAZA;EAKE,2BAA2B;EAG3B,iCAAiC;AAInC;AAZA;EAGE,UAAU;AASZ;AAZA;EAGE,SAAU;AASZ;AACA;EAEE,qBAAqB;EACrB,WAAW;AACb;AAJA;EACE,2BAA2B;AAG7B;;AAEA;;;;EAIE,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;EACE,OAAO;EAGP,cAAc;;EAEd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AAbA;EAEE,gBAAgB;EAChB,gBAAgB;AAUlB;AAbA;EAEE,iBAAgB;EAChB,iBAAgB;AAUlB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,oBAAiB;KAAjB,iBAAiB;EAIjB,sBAAsB;AACxB;AATA;EAGE,kBAAkB;EAGlB,mBAAmB;EACnB,yBAAyB;AAE3B;AATA;EAKE,iBAAiB;AAInB;AATA;EAKE,gBAAiB;AAInB;AACA;EAME,WAAW;EACX,aAAa;EACb,mBAAmB;EAEnB,4BAA4B;EAC5B,kBAAkB;EAElB,QAAQ;EAER,UAAU;AACZ;AAhBA;EACE,gBAAgB;EAChB,YAAY;EAGZ,eAAe;EAIf,kBAAkB;EAKlB,2BAA2B;AAE7B;AAhBA;EAGE,kBAAkB;EAClB,gBAAgB;EAQhB,UAAU;AAIZ;AAhBA;EAGE,kBAAkB;EAClB,iBAAgB;EAQhB,SAAU;AAIZ;AACA;EAEE,cAAc;AAChB;AAHA;EACE,mBAAmB;AAErB;AACA;EAIE,WAAW;EACX,WAAW;EACX,2BAA2B;AAC7B;AAPA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAI7B;AACA;EACE,WAAW;EACX,aAAa;AAEf;AAJA;EAGE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,oBAAe;SAAf,eAAe;EACjB;EACA;IAGE,WAAW;EACb;EAJA;IAEE,gBAAgB;EAElB;EAJA;IACE,iBAAiB;EAGnB;EAJA;IACE,gBAAiB;EAGnB;EACA;IAEE,WAAW;EACb;EAHA;IACE,gBAAgB;EAElB;EAHA;IACE,iBAAgB;EAElB;AACF;;AAEA;EACE;IACE,oBAAe;SAAf,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EAFA;IACE,iBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EAFA;IACE,eAAc;EAChB;AACF","sourcesContent":[".locationPickerWrapper {\n  position: absolute;\n}\n\n.menuControlButton {\n  margin-right: 4px !important;\n}\n\n.notSelected {\n  border: 1px solid transparent;\n}\n\n.locationItem:hover {\n  text-decoration: underline !important;\n  color: #444 !important;\n}\n\n.appMenu {\n  width: 100vw;\n  background: #f7dbd4;\n  position: relative;\n  padding-top: 32px;\n  padding-bottom: 32px;\n  display: flex;\n  justify-content: center;\n}\n.menuContainer {\n  background: #fff;\n  padding: 24px;\n  margin: 0 auto;\n  max-width: none;\n  width: 100%;\n}\n.menuDescription {\n  font-size: 1.1rem;\n  color: #333;\n  margin: 0 0 16px 0;\n}\n\n.groupIcon {\n  width: 20px;\n  height: 20px;\n  vertical-align: middle;\n  flex-shrink: 0;\n}\n.menuSearchWrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n.menuSearch {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n.pillButton {\n  background: #f9fafb;\n  border: 1.5px solid #d1d5db;\n  border-radius: 4px;\n  padding: 8px 16px 8px 12px;\n  font-size: 0.95rem;\n  color: #222;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    border 0.15s,\n    box-shadow 0.15s;\n  outline: none;\n  position: relative;\n  min-width: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n.pillButton:hover {\n  background: #b5b5b5;\n  border-color: #343c42;\n  box-shadow: none;\n}\n.pillButton:focus {\n  outline: none;\n}\n\n.pillText {\n  flex: 1;\n  text-align: left;\n  font-weight: 500;\n}\n.pillIcons {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: 8px;\n}\n.arrowIcon {\n  color: #2563eb;\n  margin-right: 2px;\n  vertical-align: middle;\n}\n.closeButton {\n  background: none;\n  border: none;\n  padding: 0 0 0 2px;\n  margin-left: 2px;\n  cursor: pointer;\n  color: #888;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  transition: background 0.15s;\n}\n.closeButton:focus {\n  outline: none;\n}\n.closeButton:hover {\n  background: #f3f4f6;\n  color: #ef4444;\n}\n.allPill {\n  margin-bottom: 12px;\n  font-weight: 700;\n  background: #f3f4f6;\n  border: 2px solid #dbeafe;\n  color: #2563eb;\n}\n.pillButton + .allPill {\n  margin-top: 16px;\n}\n.pillButton:not(:first-child) {\n  margin-top: 0;\n}\n.pillButton:not(.allPill) {\n  margin-bottom: 8px;\n}\n.menuContentWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.countriesColumn,\n.groupsColumn {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.columnTitle {\n  font-weight: 700;\n  font-size: 1.1rem;\n  margin-bottom: 12px;\n  color: #222;\n}\n.pillList {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.customGroupsSection {\n  margin-top: 32px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e7eb;\n}\n.customGroupsTitle {\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #222;\n}\n\n.customGroupsList {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  color: #444;\n}\n\n.customGroupItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  margin-bottom: 4px;\n  background: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #e9ecef;\n  gap: 8px;\n}\n\n.customGroupItem:hover {\n  background: #e9ecef;\n}\n\n.customGroupName {\n  background: none;\n  border: none;\n  padding: 8px 12px;\n  font-size: inherit;\n  color: #333;\n  cursor: pointer;\n  text-align: left;\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 4px;\n}\n\n.customGroupName:hover {\n  color: #007bff;\n  text-decoration: underline;\n}\n\n.customGroupName.selected {\n  background: #007bff;\n  color: white;\n  font-weight: bold;\n  border: 2px solid #0056b3;\n}\n\n.customGroupName.selected:hover {\n  background: #0056b3;\n  color: white;\n  text-decoration: none;\n}\n\n.groupNameText {\n  flex: 1;\n}\n\n.editIcon {\n  width: 16px;\n  height: 16px;\n  color: #6c757d;\n}\n\n.customGroupActions {\n  display: flex;\n  gap: 4px;\n}\n\n.customGroupEdit,\n.customGroupDelete {\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  opacity: 0.7;\n  border-radius: 4px;\n}\n\n.customGroupEdit:hover,\n.customGroupDelete:hover {\n  opacity: 1;\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.deleteIcon {\n  width: 18px;\n  height: 18px;\n  color: #dc3545;\n}\n\n.groupFlagPreview {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.previewFlag {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid white;\n  object-fit: cover;\n  margin-left: -8px;\n  position: relative;\n}\n\n.previewFlag:first-child {\n  margin-left: 0;\n}\n\n.moreCountriesIndicator {\n  margin-left: 4px;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n  background: #f3f4f6;\n  padding: 2px 6px;\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: white;\n  padding: 24px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.modalContent h3 {\n  margin: 0 0 16px 0;\n  color: #333;\n}\n\n.formGroup {\n  margin-bottom: 16px;\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: 4px;\n  font-weight: 600;\n  color: #333;\n}\n\n.input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.input:focus {\n  outline: none;\n}\n\n.countrySelector {\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 8px;\n  background: #f8f9fa;\n}\n\n.countryCheckbox {\n  display: flex;\n  align-items: center;\n  padding: 6px 0;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.countryCheckbox input {\n  margin-right: 8px;\n}\n\n.countryFlag {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  margin-right: 8px;\n  object-fit: cover;\n}\n\n.countryName {\n  flex: 1;\n}\n\n.customGroupSearchWrapper {\n  margin-bottom: 12px;\n}\n\n.customGroupSearchInput {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n.customGroupSearchInput:focus {\n  outline: none;\n}\n\n.selectedCountries {\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n  font-size: 16px;\n}\n\n.selectedCountriesLabel::after {\n  content: ': ';\n}\n\n.selectedCountriesPills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.countryPill {\n  display: flex;\n  align-items: center;\n  background: #f9fafb;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  padding: 3px 4px 3px 6px;\n  font-size: 14px;\n  color: #222;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n  transition: all 0.15s;\n}\n\n.countryPill:hover {\n  background: #e5e7eb;\n  border-color: #9ca3af;\n}\n\n.pillFlag {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin-right: 5px;\n  object-fit: cover;\n}\n\n.pillText {\n  font-weight: 500;\n  margin-right: 3px;\n}\n\n.pillRemove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 1px;\n  border-radius: 4px;\n  transition: background 0.15s;\n  color: #6b7280;\n}\n\n.pillRemove:hover {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.pillCloseIcon {\n  width: 12px;\n  height: 12px;\n}\n\n.noSelection {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.cancelButton {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background: white;\n  color: #333;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancelButton:hover {\n  background: #f8f9fa;\n}\n\n.saveButton {\n  padding: 8px 16px;\n  border: none;\n  background: #007bff;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.saveButton:hover {\n  background: #0056b3;\n}\n.menuSearch:focus {\n  outline: none;\n}\n\n@media (min-width: 901px) {\n  .menuContentWrapper {\n    flex-direction: row;\n    gap: 32px;\n  }\n  .pillButton {\n    min-width: 120px;\n    font-size: 1rem;\n    padding: 10px 28px 10px 18px;\n  }\n}\n\n.countriesSectionBox {\n  background: none;\n  border: 1.5px solid #d1d5db;\n  border-radius: 4px;\n  padding: 10px 20px 10px 20px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  width: 100%;\n}\n.groupsSectionBox {\n  background: none;\n  border: 1.5px solid #d1d5db;\n  border-radius: 4px;\n  padding: 10px 20px 10px 20px;\n  margin-left: 0;\n  margin-bottom: 0;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  width: 100%;\n}\n.menuContentWrapperGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: stretch;\n}\n.countriesColumnGrid {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.groupsColumnGrid {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.countriesGrid {\n  column-count: 1;\n  column-gap: 20px;\n  margin-top: 8px;\n}\n.groupsListGrid {\n  margin-top: 8px;\n}\n.countriesGrid > a,\n.countriesGrid > button,\n.groupsListGrid > a,\n.groupsListGrid > button {\n  break-inside: avoid;\n  width: 100%;\n  margin-bottom: 8px;\n}\n.squareButton {\n  background: #fff;\n  border: 1.5px solid #d1d5db;\n  border-radius: 4px;\n  padding: 4px 8px 4px 8px;\n  font-size: 1rem;\n  color: #222;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    border 0.15s,\n    box-shadow 0.15s;\n  outline: none;\n  min-width: 0;\n  min-height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n  font-weight: 500;\n  position: relative;\n  overflow: visible;\n  height: auto !important;\n  width: 100%;\n  text-decoration: none;\n}\n\n.squareButton:visited,\n.squareButton:focus,\n.squareButton:active {\n  color: #222;\n  text-decoration: none;\n}\n.squareButton.selected {\n  background: #ccced0;\n  border: 1.5px solid #343c42;\n  border-radius: 4px;\n  font-weight: bold;\n  padding-right: 23px;\n}\n/* Decorative close (x) on selected buttons – matches measures tab & custom groups */\n.squareButton.selected::after {\n  content: '';\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  background: rgba(52, 60, 66, 0.5);\n  -webkit-mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1zdmc9ImNsb3NlIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGNDkxMDMiIHN0cm9rZS13aWR0aD0iMi4wNiIgZD0iTTE2IDE2IDQgNE0xNiA0IDQgMTYiLz48L3N2Zz4=');\n  mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1zdmc9ImNsb3NlIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGNDkxMDMiIHN0cm9rZS13aWR0aD0iMi4wNiIgZD0iTTE2IDE2IDQgNE0xNiA0IDQgMTYiLz48L3N2Zz4=');\n  pointer-events: none;\n}\n.squareButton:hover {\n  border: 1.5px solid #343c42;\n  text-decoration: none;\n  color: #222;\n}\n\n.squareButton:hover .squareText,\n.squareButton:focus .squareText,\n.squareButton:active .squareText,\n.squareButton:visited .squareText {\n  color: inherit;\n}\n.squareButton.selected:hover {\n  background: #b5b5b5 !important;\n  border-color: #343c42 !important;\n  box-shadow: none !important;\n}\n.squareText {\n  flex: 1;\n  text-align: left;\n  margin-left: 4px;\n  color: inherit;\n\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n  display: block;\n  max-width: 100%;\n  line-height: 1.2;\n  word-break: break-word;\n}\n.flagIcon {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-right: 2px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  align-self: flex-start;\n}\n.closeButton {\n  background: none;\n  border: none;\n  padding: 0 0 0 2px;\n  margin-left: 6px;\n  cursor: pointer;\n  color: #888;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  transition: background 0.15s;\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n}\n.closeButton:hover {\n  background: #f3f4f6;\n  color: #ef4444;\n}\n.allButton {\n  margin-bottom: 0;\n  background: #fff;\n  border: 1.5px solid #d1d5db;\n  color: #222;\n  width: auto;\n  justify-content: flex-start;\n}\n.allRow {\n  width: 100%;\n  display: flex;\n  margin-bottom: 0;\n}\n.menuSearch:focus {\n  outline: none;\n}\n\n@media (min-width: 768px) {\n  .menuContentWrapperGrid {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n  .countriesColumnGrid {\n    flex: 2 1 0;\n  }\n  .groupsColumnGrid {\n    flex: 1 1 0;\n  }\n  .countriesGrid {\n    column-count: 2;\n  }\n  .countriesSectionBox {\n    margin-right: 8px;\n    margin-bottom: 0;\n    width: auto;\n  }\n  .groupsSectionBox {\n    margin-left: 8px;\n    width: auto;\n  }\n}\n\n@media (min-width: 1100px) {\n  .countriesGrid {\n    column-count: 3;\n  }\n  .countriesSectionBox {\n    margin-right: 12px;\n  }\n  .groupsSectionBox {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationPickerWrapper": `locationPickerWrapper--beSnT`,
	"menuControlButton": `menuControlButton--O0jyb`,
	"notSelected": `notSelected--OphPu`,
	"locationItem": `locationItem--NEbE5`,
	"appMenu": `appMenu--AvGfm`,
	"menuContainer": `menuContainer--Dj14U`,
	"menuDescription": `menuDescription--ALqlF`,
	"groupIcon": `groupIcon--x10F_`,
	"menuSearchWrapper": `menuSearchWrapper--qwocF`,
	"menuSearch": `menuSearch--DnCrf`,
	"pillButton": `pillButton--ceOQa`,
	"pillText": `pillText--GdlXQ`,
	"pillIcons": `pillIcons--Fy9Al`,
	"arrowIcon": `arrowIcon--efgol`,
	"closeButton": `closeButton--HEQqf`,
	"allPill": `allPill--y7XVt`,
	"menuContentWrapper": `menuContentWrapper--Dv_dl`,
	"countriesColumn": `countriesColumn--Hkt0B`,
	"groupsColumn": `groupsColumn--_GqjZ`,
	"columnTitle": `columnTitle--vr3uz`,
	"pillList": `pillList--ImzY0`,
	"customGroupsSection": `customGroupsSection--X0yh5`,
	"customGroupsTitle": `customGroupsTitle--SArml`,
	"customGroupsList": `customGroupsList--oRPXS`,
	"customGroupItem": `customGroupItem--L080k`,
	"customGroupName": `customGroupName--FSt1z`,
	"selected": `selected--grTxE`,
	"groupNameText": `groupNameText--CyjkB`,
	"editIcon": `editIcon--JwCV4`,
	"customGroupActions": `customGroupActions--WOedA`,
	"customGroupEdit": `customGroupEdit--PU_ON`,
	"customGroupDelete": `customGroupDelete--Zb41P`,
	"deleteIcon": `deleteIcon--okfaJ`,
	"groupFlagPreview": `groupFlagPreview--HkWfT`,
	"previewFlag": `previewFlag--pIyZa`,
	"moreCountriesIndicator": `moreCountriesIndicator--soIY7`,
	"modal": `modal--gV4LK`,
	"modalContent": `modalContent--tO7DF`,
	"formGroup": `formGroup--BnU4d`,
	"input": `input--sTVzk`,
	"countrySelector": `countrySelector--fn4xn`,
	"countryCheckbox": `countryCheckbox--d2T53`,
	"countryFlag": `countryFlag--UlCxY`,
	"countryName": `countryName--_wdtJ`,
	"customGroupSearchWrapper": `customGroupSearchWrapper--_Z4mF`,
	"customGroupSearchInput": `customGroupSearchInput--GiYpA`,
	"selectedCountries": `selectedCountries--xw5gp`,
	"selectedCountriesLabel": `selectedCountriesLabel--YW8Mq`,
	"selectedCountriesPills": `selectedCountriesPills--Rl9HH`,
	"countryPill": `countryPill--b9yia`,
	"pillFlag": `pillFlag--iRpcV`,
	"pillRemove": `pillRemove--Cp18r`,
	"pillCloseIcon": `pillCloseIcon--ABLLE`,
	"noSelection": `noSelection--q2sOw`,
	"modalActions": `modalActions--FLEm3`,
	"cancelButton": `cancelButton--bWwcR`,
	"saveButton": `saveButton--rBMfK`,
	"countriesSectionBox": `countriesSectionBox--VXoZy`,
	"groupsSectionBox": `groupsSectionBox--BCQ5w`,
	"menuContentWrapperGrid": `menuContentWrapperGrid--wRmE_`,
	"countriesColumnGrid": `countriesColumnGrid--RgkGL`,
	"groupsColumnGrid": `groupsColumnGrid--NDcGL`,
	"countriesGrid": `countriesGrid--oegCj`,
	"groupsListGrid": `groupsListGrid--Qp6nY`,
	"squareButton": `squareButton--BhbXx`,
	"squareText": `squareText--w94XJ`,
	"flagIcon": `flagIcon--zoxVx`,
	"allButton": `allButton--AFgM3`,
	"allRow": `allRow--VRhjY`
};
export default ___CSS_LOADER_EXPORT___;
